export const colorMarkName = 'color';
export const colorClassName = 'yfm-colorify';
export const domColorAttr = 'data-color';
